import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy">
      <div className="privacy-container">
        <h1>Gizlilik Politikası</h1>
        <p className="privacy-intro">
          Son Güncelleme: 10 Eylül 2026
        </p>
        
        <div className="privacy-content">
          <section className="privacy-section">
            <p>
              Travel Istanbul ("uygulama"), kullanıcılarının gizliliğine büyük önem verir. Bu gizlilik politikası, kişisel bilgilerinizin nasıl toplandığını, kullanıldığını, paylaşıldığını ve korunduğunu açıklamaktadır. Ayrıca, kişisel verilerinizle ilgili sahip olduğunuz hakları ve tercihlerinizi nasıl kullanabileceğinizi belirtir.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Veri Toplama</h2>
            <p>
              Uygulama kapsamında isim, soyisim, e-posta adresi ve konum bilgisi gibi kişisel verileriniz toplanmaktadır. Bu veriler, abonelik yönetimi, kullanıcı hesabınızın kontrolü ve abonelikle ilgili iletişim amaçlarıyla kullanılmaktadır. Uygulama dışında otomatik olarak toplanan veriler veya üçüncü taraflardan veri alımı bulunmamaktadır.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Veri Saklama</h2>
            <p>
              Toplanan verilerden isim, soyisim ve e-posta bilgileri veritabanında güvenli şekilde saklanmaktadır. <strong>Konum verisi ise sadece kullanıcı deneyimini geliştirmek amacıyla kullanılmakta ve cihaz üzerinde, lokal olarak tutulmaktadır. Konum verisi hiçbir şekilde üçüncü taraflarla paylaşılmamaktadır.</strong>
            </p>
          </section>

          <section className="privacy-section">
            <h2>Üçüncü Taraf Paylaşımı</h2>
            <p>
              Kişisel verileriniz yalnızca kullanıcı kimlik doğrulama süreçlerinde görev alan hizmet sağlayıcılarla sınırlı şekilde işlenmektedir. Bu veriler reklam veya başka ticari amaçlarla kullanılmaz ve başka hiçbir üçüncü tarafla paylaşılmaz.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Kullanıcı Hakları</h2>
            <p>
              Kullanıcılar uygulama içinden isim, soyisim ve e-posta bilgilerini güncelleyebilir, ayrıca hesaplarını ve kişisel verilerini silebilirler. Verilerinizin işlenmesini reddetme hakkınız bulunmaktadır; ancak bu durumda uygulamanın sadece ücretsiz özellikleri kullanılabilir.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Çerez ve İzleme Teknolojileri</h2>
            <p>
              Travel Istanbul uygulaması, kullanıcı deneyimini iyileştirmek amacıyla bazı verileri yalnızca cihaz üzerinde, lokal veritabanlarında saklamaktadır. Ancak bu uygulamada <strong>çerez veya benzeri web tabanlı izleme teknolojileri kullanılmamaktadır.</strong>
            </p>
          </section>

          <section className="privacy-section">
            <h2>Ödeme Bilgileri</h2>
            <p>
              Uygulama, freemium modelinde abonelik esaslı hizmet sunmakta olup, ödemeler Android cihazlarda <strong>Google Play Faturalandırma</strong>, iOS cihazlarda <strong>Apple In-App Purchase</strong> sistemi üzerinden gerçekleşmektedir. Ödeme bilgileri doğrudan bu platformlar tarafından güvenli şekilde işlenir ve biz bu bilgilere erişim sağlamamaktayız.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Veri Güvenliği</h2>
            <p>
              Toplanan kişisel verileriniz, güçlü şifreleme yöntemleriyle korunmakta ve yetkisiz erişime karşı güvenlik önlemleri alınmaktadır.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Veri Saklama Süresi</h2>
            <p>
              Kişisel verileriniz, siz silme talebinde bulunmadığınız sürece saklanmaya devam eder.
            </p>
          </section>

          <section className="privacy-section">
            <h2>İletişim</h2>
            <p>
              Kişisel verilerinizle ilgili sorularınız için <strong><a href="mailto:travelistanbulapp@gmail.com">travelistanbulapp@gmail.com</a></strong> adresinden bizimle iletişime geçebilirsiniz.
            </p>
            <p>
              <strong>Web Sitesi:</strong> <a href="https://www.travelistanbulapp.com" target="_blank" rel="noopener noreferrer">https://www.travelistanbulapp.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
